import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.board.editor');
import { OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-board-editor',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.board.editor/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
}`],
})
export class PortalBoardEditorComponent implements OnInit {
    @Input() boardId: string = '';
    @Input() postId: string = '';
    @Output() onSave = new EventEmitter<string>();
    @Output() onCancel = new EventEmitter<void>();
    @ViewChild('fileInput') fileInput: ElementRef;

    public loading: boolean = false;
    public saving: boolean = false;
    public isEdit: boolean = false;
    public categories: any[] = [];
    public files: File[] = [];
    public existingAttachments: any[] = [];

    public data: any = {
        title: '', content: '', category_id: '', is_notice: false
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadCategories();
        if (this.postId) {
            this.isEdit = true;
            await this.loadPost();
        }
        await this.service.render();
    }

    public async loadCategories() {
        if (!this.boardId) return;
        const params = new URLSearchParams();
        params.append('board_id', this.boardId);
        try {
            const res = await fetch('/api/board/board-info', { method: 'POST', body: params });
            const result = await res.json();
            if (res.ok) {
                this.categories = result.data?.categories || [];
            }
        } catch (e) { }
    }

    public async loadPost() {
        const params = new URLSearchParams();
        params.append('post_id', this.postId);
        try {
            const res = await fetch('/api/board/post-get', { method: 'POST', body: params });
            const result = await res.json();
            if (res.ok) {
                const post = result.data;
                this.data = {
                    title: post.title || '',
                    content: post.content || '',
                    category_id: post.category_id || '',
                    is_notice: post.is_notice || false
                };
                this.boardId = post.board_id;
                this.existingAttachments = post.attachments || [];
            }
        } catch (e) { }
    }

    public triggerFileInput() {
        if (this.fileInput) {
            this.fileInput.nativeElement.click();
        }
    }

    public async onFileSelect(event: any) {
        const selectedFiles = event.target.files;
        if (selectedFiles) {
            for (let i = 0; i < selectedFiles.length; i++) {
                this.files.push(selectedFiles[i]);
            }
        }
        event.target.value = '';
        await this.service.render();
    }

    public async removeFile(index: number) {
        this.files.splice(index, 1);
        await this.service.render();
    }

    public formatFileSize(bytes: number): string {
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }

    public async save() {
        if (!this.data.title) {
            await this.service.modal.error("제목을 입력해주세요.");
            return;
        }

        this.saving = true;
        await this.service.render();

        const formData = new FormData();
        formData.append('board_id', this.boardId);
        formData.append('title', this.data.title);
        formData.append('content', this.data.content);
        formData.append('category_id', this.data.category_id);
        formData.append('is_notice', String(this.data.is_notice));

        const action = this.isEdit ? 'post-update' : 'post-create';
        if (this.isEdit) {
            formData.append('post_id', this.postId);
        }

        for (const file of this.files) {
            formData.append('file[]', file);
        }

        try {
            const res = await fetch(`/api/board/${action}`, { method: 'POST', body: formData });
            const result = await res.json();
            if (res.ok) {
                const savedId = this.isEdit ? this.postId : result.data?.id;
                await this.service.modal.success(this.isEdit ? "수정되었습니다." : "게시물이 등록되었습니다.");
                this.onSave.emit(savedId);
            } else {
                await this.service.modal.error(result.message || "저장 실패");
            }
        } catch (e) {
            await this.service.modal.error("서버 오류");
        }

        this.saving = false;
        await this.service.render();
    }

    public cancel() {
        this.onCancel.emit();
    }
}

export default PortalBoardEditorComponent;